import { Component, OnInit } from '@angular/core';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';

@Component({
  selector: 'app-overview-loyalty-value',
  templateUrl: './overview-loyalty-value.component.html',
  styleUrls: ['./overview-loyalty-value.component.css']
})
export class OverviewLoyaltyValueComponent implements OnInit {

  public indicators: IndicatorBoxModel[] = [];

  translations: any;

  fatturatoChart: LoyaltyChart;
  penetrazioneCartaChart: LoyaltyChart;

  public data: QFilterModel;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.translate.get([
      'loyalty_chart.fatturato',
      'loyalty_chart.penetrazioneCarta',
      'loyalty_chart.period'
    ]).subscribe((t) => {
      this.translations = {
        fatturato: t['loyalty_chart.fatturato'],
        penetrazioneCarta: t['loyalty_chart.penetrazioneCarta'],
        etichetta_periodo: t['loyalty_chart.period']
      };

      this.initCharts();
    });
  }

  initCharts() {
    this.fatturatoChart = (new LoyaltyChart('column', '€'));
    this.fatturatoChart.options.plotOptions = {column: {stacking: 'normal'}};
    this.fatturatoChart.options.xAxis.title.text = this.translations.etichetta_periodo;
    this.penetrazioneCartaChart = new LoyaltyChart('line', '%');
    this.penetrazioneCartaChart.options.xAxis.title.text = this.translations.etichetta_periodo;
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  public searchValueTrend(data: QFilterModel) {
    this.data = data;

    this.translate.get([
      'indicator.scontrino_medio_carta',
      'indicator.fatturato_carta',
      'indicator.transazioni_carta',
      'indicator.spesa_media_carta',
      'indicator.penetrazione',
      'indicator.noCarta'
    ]).subscribe(t => {
      this.indicators = [];

      this.indicatorService.indicatorCalculation('Q023', this.data).switchMap((res) => {
        const fatturato = [
          res.find(ind => ind.name === 'fatturato_carta'),
          res.find(ind => ind.name === 'penetrazione_fatturato')
        ];
        const transazioni = [
          res.find(ind => ind.name === 'transazioni_carta'),
          res.find(ind => ind.name === 'penetrazione_transazioni')
        ];

        const fatturato_penetrazione = new IndicatorBoxModel(fatturato, {dynamic: true}, t);
        fatturato_penetrazione.penetration.unitOfMeasure = '% ' + t['indicator.penetrazione'];

        const transazioni_penetrazione = new IndicatorBoxModel(transazioni, {dynamic: true}, t);
        transazioni_penetrazione.penetration.unitOfMeasure = '% ' + t['indicator.penetrazione'];

        this.indicators.push(fatturato_penetrazione);
        this.indicators.push(transazioni_penetrazione);

        return this.indicatorService.indicatorCalculation('Q025', this.data);
      }).switchMap((res) => {
        this.indicators.push(new IndicatorBoxModel(res, {unit_period_prec: '€'}, t));
        return this.indicatorService.indicatorCalculation('Q026', this.data);
      }).subscribe((res) => {

        const scontrino_medio_no_carta = new IndicatorBoxModel(res, {unit_period_prec: '€'}, t);
        scontrino_medio_no_carta.penetration.unitOfMeasure = '€ ' + t['indicator.noCarta'];

        this.indicators.push(scontrino_medio_no_carta);
      });

    });

    this.chartsService.loadChart(this.fatturatoChart, 'Q027A', data, this.indicatorService, this.translate);
    const colors = [LoyaltyChart.colors[3], LoyaltyChart.colors[4]];
    this.chartsService.loadChart(this.penetrazioneCartaChart, 'Q027B', data, this.indicatorService, this.translate, false, colors);
  }

  public resetData() {
    this.indicators = [];
    this.data = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/overview/overview-loyalty/overview-loyalty-value/overview-loyalty-value.component.ts